import '../styles/page-terms.css';
import Seo from '../components/Seo';
export default function TermsPage() {
  
  return (
    <>
      <Seo title="Terms of Service | TeamGrid™" description="Plain-English terms for using TeamGrid: per-active-user billing, cancel anytime, free data exports, and your workspace data stays yours throughout." />
<header className="lg-hero">
  <div className="container">
    <h1 className="sect-h2" style={{fontSize: '48px', lineHeight: '56px', letterSpacing: '-2px'}}>Terms of Service</h1>
    <p className="sect-sub">Plain-English terms for using TeamGrid.</p>
    <div className="tldr">
      <div className="tl"><span className="te">🤝</span><b>Fair deal</b><span>Pay per active user, cancel anytime, data exports free.</span></div>
      <div className="tl"><span className="te">⚖️</span><b>Use it lawfully</b><span>Tell your team it’s running; follow local employment law.</span></div>
      <div className="tl"><span className="te">🔒</span><b>Your content is yours</b><span>We claim no ownership over your data. Ever.</span></div>
      <div className="tl"><span className="te">📅</span><b>Trial honesty</b><span>7 days free, no card, no auto-charge.</span></div>
    </div>
    <div className="legal">
      <p className="upd">LAST UPDATED — JULY 2026</p>
      <h3>1. The service</h3>
      <p>TeamGrid provides workforce intelligence: patterns, analytics, AI summaries, CRM and HRMS modules, delivered through our agent and web application. We keep the service available per our published uptime history.</p>
      <h3>2. Your responsibilities</h3>
      <p>Deploy TeamGrid transparently and in line with the laws of your jurisdiction, including informing employees where required. You’re responsible for the accuracy of account data and the conduct of users in your workspace.</p>
      <h3>3. Billing</h3>
      <p>Plans are billed per active user, monthly or annually. Trials never convert to paid automatically. Fees are non-refundable except where required by law or where we fail our uptime commitment.</p>
      <h3>4. Data & ownership</h3>
      <p>Your workspace data belongs to you. We process it solely to provide the service, under our Privacy Policy. On termination you may export everything; we delete within 30 days.</p>
      <h3>5. Liability</h3>
      <p>TeamGrid provides insight, not employment decisions — how you act on patterns is your call, and material decisions should never rest on a single signal. Our liability is capped at fees paid in the prior 12 months.</p>
      <h3>6. Changes</h3>
      <p>We’ll notify workspace admins 30 days before material changes to these terms take effect.</p>
    </div>
  </div>
</header>
    </>
  );
}
